import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  mbHalf: {
    marginBottom: "4px"
  },
  peopleWithAccessTitle: {
    marginTop: "16px",
    marginBottom: "4px",
  },
  mlHalf: {
    marginLeft: "4px"
  },
  mt16: {
    marginTop: "16px"
  },
  autoComplete: {
    width: "100%"
  },
  closeIcon: {
    marginTop: "8px",
    color: capitalDesignTokens.semanticColors.foreground.errorSmall
  },
  option: {
    "&.MuiAutocomplete-option.MuiBox-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      padding: "8px 24px",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  },
  optionDetailsCol: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    textAlign: "left",
    overflow: "hidden",
  },
  optionLabel: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userEmail: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userGroupMemberCount: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
    color: capitalDesignTokens.foundations.colors.brand700,
  },
  optionStatus: {
    flexShrink: 0,
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    display: "flex",
    alignItems: "center",
    "& .MuiSvgIcon-root": {
      marginRight: "4px",
      width: "16px",
      height: "16px",
    },
  },
});
